import BuyTicketRoute from './payment-ready.route';
angular.module('BTMS')
.config(BuyTicketRoute);



/** WEBPACK FOOTER **
 ** ./client/public/main/payment-ready/index.js
 **/